import { render, staticRenderFns } from "./DependencyIndexWrapper.vue?vue&type=template&id=a107e030&"
import script from "./DependencyIndexWrapper.vue?vue&type=script&lang=js&"
export * from "./DependencyIndexWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports